export default "__VITE_ASSET__CWQIIk9O__"